import { TONE_LABELS, TONES } from "@sonic-five-elements/contracts";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

export function HomePage() {
  useEffect(() => { void api.track("landing_view"); }, []);
  return <>
    <section className="hero">
      <div className="hero-copy">
        <p className="eyebrow">AN ANCIENT IDEA, HEARD ANEW</p>
        <h1>Find your element.<br /><em>Hear your moment.</em></h1>
        <p className="hero-lead">Create an AI instrumental soundscape or an original song with editable English lyrics, inspired by the traditional Chinese Five Tones.</p>
        <div className="hero-actions"><Link className="button primary" to="/create">Create your music</Link><Link className="button ghost" to="/pricing">Explore plans</Link></div>
        <p className="microcopy">Try one 30-second instrumental and one 30-second vocal song free. No card required.</p>
      </div>
      <div className="hero-orbit" aria-hidden="true">
        <div className="orbit-ring one" /><div className="orbit-ring two" />
        <div className="center-disc"><span>五</span><small>FIVE TONES</small></div>
        {TONES.map((tone, index) => <span key={tone} className={`orbit-dot dot-${index + 1}`}>{TONE_LABELS[tone].element}</span>)}
      </div>
    </section>

    <section className="intro-section">
      <p className="eyebrow">THE FIVE-TONE PALETTE</p>
      <h2>Five characters of sound</h2>
      <p className="section-lead">Each tone offers a different musical starting point. Use it for a restorative instrumental or combine it with an original vocal song up to four minutes long.</p>
      <div className="tone-grid">
        {TONES.map((tone, index) => <article className={`tone-card tone-${tone}`} key={tone}>
          <span className="tone-number">0{index + 1}</span><span className="tone-character">{["角", "徵", "宫", "商", "羽"][index]}</span>
          <h3>{TONE_LABELS[tone].title} <small>/ {TONE_LABELS[tone].element}</small></h3>
          <p>{TONE_LABELS[tone].description}</p>
          <audio controls preload="none" aria-label={`${TONE_LABELS[tone].title} sample`} onPlay={() => void api.track("sample_play", { properties: { tone } })}><source src={`/samples/${tone}.mp3`} type="audio/mpeg" /></audio>
        </article>)}
      </div>
    </section>

    <section className="steps-section">
      <div><p className="eyebrow">TWO WAYS TO CREATE</p><h2>Instrumental calm.<br />Songs with a voice.</h2></div>
      <ol className="steps-list">
        <li><span>01</span><div><h3>Five-Tone AI instrumentals</h3><p>Choose an element, mood, Chinese instrument and a duration from 30 to 240 seconds. No prompt writing required.</p></div></li>
        <li><span>02</span><div><h3>AI song generator with English lyrics</h3><p>Describe a scene or paste rough lyrics. AI creates an original, editable English lyric draft, production direction and vocal style.</p></div></li>
        <li><span>03</span><div><h3>You review before music generation</h3><p>See and edit the title, lyrics, prompt, element, mood, instrument and vocal style before spending credits.</p></div></li>
      </ol>
    </section>

    <section className="steps-section alternate-steps">
      <div><p className="eyebrow">A SIMPLE RITUAL</p><h2>From intention<br />to music</h2></div>
      <ol className="steps-list">
        <li><span>01</span><div><h3>Choose your element</h3><p>Begin with one of the Five Tones and its expressive character.</p></div></li>
        <li><span>02</span><div><h3>Shape the atmosphere</h3><p>Select a mood, instrument and listening duration.</p></div></li>
        <li><span>03</span><div><h3>Listen to something new</h3><p>Your original AI-generated instrumental or vocal song arrives as a high-quality MP3.</p></div></li>
      </ol>
    </section>

    <section className="closing-cta"><p className="eyebrow">YOUR MOMENT IS WAITING</p><h2>Create your Five-Tone journey</h2><Link className="button light" to="/create">Try both modes free</Link></section>
  </>;
}
